import AuthenticationService from '../../service/authentication-service';
import displayNetworkError from '../../helpers/displayNetworkError';

import { actionsAlpha, actionsBeta } from './auth-actions';
import { makeUserActions } from './user-actions';
import { makeProjectActions } from './project-actions';
import { makeCuesheetActions } from './cuesheet-actions';
import { makeMediaActions } from './media-actions';
import { makeAudioActions, actionsCaching } from './audio-actions';
import { makePlansActions } from './plans-actions';
import { makeMessagesActions } from './messages-actions';
import { makeRecSessionActions } from './rec-session-actions';

export { actionsAlpha, actionsBeta, actionsCaching };

export const actionsReactQuery = ({ set, get }) => {
    const {
        fetchUserDataImpl,
        fetchUserData,
        refetchUserData,
        fetchUserCounters,
        updateUser,
        updateUserPreferences,
    } = makeUserActions(set, get);

    const {
        fetchProjectsImpl,
        refetchProjectsImpl,
        fetchProjectTeamImpl,
        refetchProjectTeamImpl,
        fetchProjectImpl,
        fetchProjects,
        refetchProjects,
        fetchProject,
        fetchProjectTeam,
        refetchProjectTeam,
        createUpdateProject,
        createInvitationsBulkForProject,
        assignPermissions,
        unassignPermissions,
    } = makeProjectActions(set, get);

    const {
        refetchCueSheetImpl,
        fetchCueSheet,
        refetchCueSheet,
        createCueSheetItem,
        importCueSheetItems,
        deleteCueSheetItem,
        saveCueSheetUpdates,
        cutCueSheetItem,
        saveHistoryItems,
        syncCueSheetWithHistory,
        updateCalendarItemDates,
    } = makeCuesheetActions(set, get);

    const {
        fetchVideos,
        refetchVideos,
        createVideoItem,
        deleteVideoItem,
        deleteClip,
    } = makeMediaActions(set, get, { refetchCueSheetImpl });

    const {
        cacheProjectAudio,
        cleanupAudioCache,
        cacheRecSessionAudio,
        cleanupRecSessionAudio,
        cacheRecSessionAudioImpl,
        cleanupRecSessionAudioImpl,
    } = makeAudioActions(set, get);

    const {
        fetchPlans,
    } = makePlansActions(set, get);

    const {
        fetchMessages,
        sendMessage,
    } = makeMessagesActions(set, get);

    const {
        fetchRecSessions,
        createRecSession,
        uploadRecSessionTrack,
    } = makeRecSessionActions(set, get, { cacheRecSessionAudioImpl, cleanupRecSessionAudioImpl });

    return {
        login: async (credentials) => {
            try {
                const response = await AuthenticationService.loginAsync(credentials);

                if (response.access_token) {
                    set('token', response.access_token);
                    await fetchUserDataImpl();
                }
            } catch (error) {
                displayNetworkError(error);

                if (!error?.handled) {
                    throw error;
                }
            }
        },

        register: async (data, queryParams) => {
            try {
                await AuthenticationService.registerUserAsync(data, queryParams);
            } catch (error) {
                displayNetworkError(error);

                if (!error?.handled) {
                    throw error;
                }
            }
        },

        fetchUserData,
        refetchUserData,
        fetchUserCounters,
        updateUser,
        updateUserPreferences,

        fetchProjects,
        refetchProjects,
        fetchProject,
        fetchProjectTeam,
        refetchProjectTeam,
        createUpdateProject,
        createInvitationsBulkForProject,
        assignPermissions,
        unassignPermissions,

        fetchCueSheet,
        refetchCueSheet,
        createCueSheetItem,
        importCueSheetItems,
        deleteCueSheetItem,
        saveCueSheetUpdates,
        cutCueSheetItem,
        saveHistoryItems,
        syncCueSheetWithHistory,
        updateCalendarItemDates,

        fetchVideos,
        refetchVideos,
        createVideoItem,
        deleteVideoItem,
        deleteClip,

        cacheProjectAudio,
        cleanupAudioCache,
        cacheRecSessionAudio,
        cleanupRecSessionAudio,

        fetchPlans,

        fetchMessages,
        sendMessage,

        fetchRecSessions,
        createRecSession,
        uploadRecSessionTrack,
    };
};
